<div class="card-base">
  <div class="card-content-cash-desk-manual-search">
    <div class="chip-container">
      <mat-chip-list>
        <mat-chip
          color="accent"
          matTooltip="{{ filt.toolTip }}"
          selected
          *ngFor="let filt of searchFilters"
        >
          {{ filt.valueView }}
          <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()"
            >cancel</mat-icon
          >
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="card-container mat-elevation-z1">
      <div class="clearfix">
        <div class="pull-right div-header-right">
          <button
            class="card-inline margin-top-medium"
            matTooltip="Generar cobranza manual"
            (click)="invoiceManualCashDeskRedirect()"
            type="button"
            mat-mini-fab
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div class="pull-left div-header-left">
          <app-search-filter-component
            #searchFilter
            (startSearch)="onStartSearch()"
            (endSearch)="onEndSearch($event)"
            [filter]="filters"
          ></app-search-filter-component>
          <cash-desk-manual-filter #filters></cash-desk-manual-filter>
        </div>
      </div>

      <mat-divider></mat-divider>
      <div class="card-content margin-botton-medium">
        <!--<mat-spinner *ngIf="loading"></mat-spinner>-->
        <!--<p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">-->
        <p-scrollPanel styleClass="scroll-panel">
          <table
            class="search-table search-table-fixed"
            mat-table
            [dataSource]="dataSource"
          >
            <ng-container matColumnDef="Number">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="100"
                  tile="Numero"
                  #resColNumber
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>
                  <b>{{ element.Number }}</b>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="InvoiceTypeDescription">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="100"
                  tile="Tipo"
                  #resColInvoiceTypeDescription
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.InvoiceTypeDescription }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="BusinessName">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="100"
                  tile="Razón social"
                  #resColBusinessName
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.BusinessName }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="CreateDateView">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="50"
                  tile="Fecha"
                  #resColCreateDateView
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.CreateDateView }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="Amount">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="50"
                  tile="Importe"
                  #resColAmount
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.Amount }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="Protocol">
              <th
                class="search-table-header resizable-column"
                mat-header-cell
                *matHeaderCellDef
              >
                <resizable-column-control
                  width="50"
                  tile="Protocolo"
                  #resColProtocol
                ></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.Protocol }}</div>
              </td>
            </ng-container>
            <!-- Star Column -->
            <ng-container matColumnDef="Star" stickyEnd>
              <th
                class="search-table-header"
                mat-header-cell
                *matHeaderCellDef
              ></th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <button mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuItem="matMenu">
                  <button
                    *ngIf="canCreateCreditNote(element)"
                    (click)="invoiceManualCreditNoteCashDeskRedirect(element)"
                    mat-menu-item
                  >
                    <mat-icon>edit</mat-icon
                    ><span>Generar nota de crédito</span>
                  </button>
                  <button
                    (click)="invoiceManualCashDeskViewRedirect(element)"
                    mat-menu-item
                  >
                    <mat-icon>edit</mat-icon><span>Ver</span>
                  </button>

                  <button
                    *ngIf="
                      element.AppointmentIds &&
                      element.AppointmentIds.length > 0
                    "
                    (click)="sendMail(element)"
                    mat-menu-item
                  >
                    <mat-icon>mail</mat-icon><span>Enviar por mail</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr
              mat-header-row
              class="search-table-header"
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              class="search-table-cell"
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </p-scrollPanel>
        <pager
          (selectedPageIndexChange)="selectedPageIndexChange($event)"
          #pager
        ></pager>
      </div>
    </div>
  </div>
</div>
